import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const SIDE_IMG = "https://images.unsplash.com/photo-1662532577856-e8ee8b138a8b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHx3b21lbiUyMGZhc2hpb24lMjBkcmVzcyUyMGVkaXRvcmlhbHxlbnwwfHx8fDE3ODYzODM1NjR8MA&ixlib=rb-4.1.0&q=85";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Conta criada com sucesso!");
      navigate("/conta");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[calc(100vh-5rem)]">
      <div className="flex items-center justify-center px-6 py-16 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="register-form">
          <div className="overline text-[#B89C65] mb-3">Junte-se ao Ateliê</div>
          <h1 className="font-serif text-4xl text-[#1A1A1A] mb-8">Criar conta</h1>
          <div className="space-y-5">
            <div>
              <label className="overline text-[#1A1A1A]/60 block mb-2">Nome</label>
              <input data-testid="register-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required
                className="w-full bg-transparent border-b border-[#1A1A1A]/20 focus:border-[#B89C65] outline-none py-3 transition-colors" />
            </div>
            <div>
              <label className="overline text-[#1A1A1A]/60 block mb-2">E-mail</label>
              <input data-testid="register-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required
                className="w-full bg-transparent border-b border-[#1A1A1A]/20 focus:border-[#B89C65] outline-none py-3 transition-colors" />
            </div>
            <div>
              <label className="overline text-[#1A1A1A]/60 block mb-2">Senha (mín. 6 caracteres)</label>
              <input data-testid="register-password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required minLength={6}
                className="w-full bg-transparent border-b border-[#1A1A1A]/20 focus:border-[#B89C65] outline-none py-3 transition-colors" />
            </div>
          </div>
          <button data-testid="register-submit" disabled={loading}
            className="w-full bg-[#1A1A1A] text-[#F8F7F4] py-4 mt-8 overline hover:bg-[#B89C65] transition-colors disabled:opacity-60">
            {loading ? "Criando…" : "Criar conta"}
          </button>
          <p className="text-center text-[#1A1A1A]/60 mt-6 text-sm">
            Já tem conta? <Link to="/login" data-testid="go-login" className="text-[#B89C65] hover:underline">Entrar</Link>
          </p>
        </form>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src={SIDE_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" />
      </div>
    </div>
  );
}
